module.exports = __webpack_public_path__ + "img/drf.e0fe0d02.png";